import {
  collection,
  doc,
  DocumentData,
  query,
  QueryDocumentSnapshot,
  where,
} from "firebase/firestore";
import { db } from "@poseidon/firebase/firebase";
import config from "@poseidon/utils/config";
import { useEffect, useState } from "react";
import { useCollection } from "react-firebase-hooks/firestore";

export const useApplicationsSummary = (dealerId: string) => {
  const [applications, setApplications] = useState<DocumentData[]>([]);
  const [value, loading, error] = useCollection(
    query(
      collection(db, config.SaltCollection.ApplicationSummary),
      where("dealer", "==", doc(db, "dealers", dealerId))
    )
  );
  useEffect(() => {
    const run = async () => {
      if (value) {
        const docs = value.docs.map(mapApplicationsSummary);
        setApplications(docs);
      }
    };
    run();
  }, [value]);

  return { applications, loading, error };
};

const mapApplicationsSummary = (snapshot: QueryDocumentSnapshot) => {
  if (!snapshot.exists()) {
    return {};
  }

  return {
    id: snapshot.id,
    documentReference: snapshot.ref,
    ...snapshot.data(),
  };
};
